import React from 'react'
import { CircularProgress } from '@mui/material'

export const renderInlineLoading = (size = 20) => (
  <CircularProgress 
    size={size} 
    style={{ display: 'inline-block', verticalAlign: 'middle' }} 
  />
)
